import React from 'react'

import Icon from '@ant-design/icons'

const ArrowIconSVG = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M0.666504 7H12.8365L7.2465 1.41L8.6665 0L16.6665 8L8.6665 16L7.2565 14.59L12.8365 9H0.666504V7Z" />
  </svg>
)

export const ArrowIcon = (props: any) => (
  <Icon component={ArrowIconSVG} {...props} />
)
